"use client";

import Link from "next/link";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { captureException } from "@sentry/nextjs";
import { Container } from "@/components/layout/container";
import { Button } from "@/components/ui/button";
import Typography from "@/components/ui/typography";
import { useScopedI18n } from "@/locales/client";
export default function Error({
  error
}: {
  error: Error;
  reset: () => void;
}) {
  const t = useScopedI18n("error");
  useEffect(() => {
    console.error(error);
    captureException(error);
  }, [error]);
  return <Container as="main" className="flex min-h-[50vh] flex-col items-center justify-center text-center" data-sentry-element="Container" data-sentry-component="Error" data-sentry-source-file="error.tsx">
      <Typography className="mb-2" variant="h2" data-sentry-element="Typography" data-sentry-source-file="error.tsx">
        {t("title")}
      </Typography>
      <Typography className="mb-6 text-muted-foreground" variant="p" data-sentry-element="Typography" data-sentry-source-file="error.tsx">
        {t("description")}
      </Typography>
      <div className="flex gap-4">
        <Button asChild data-sentry-element="Button" data-sentry-source-file="error.tsx">
          <Link href="/" data-sentry-element="Link" data-sentry-source-file="error.tsx">
            <ArrowLeft className="mr-2 h-4 w-4" data-sentry-element="ArrowLeft" data-sentry-source-file="error.tsx" />
            {t("returnHome")}
          </Link>
        </Button>
      </div>
    </Container>;
}